module.exports = __webpack_public_path__ + "static/img/moreindustry1.36cc5b01.png";